import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';

/**
 * Checks whether feature is available in current user context
 */
export function canUseCalendarBoard(): boolean {
    return (
        isFeatureEnabled('cal-sublimity') &&
        !getUserConfiguration().SessionSettings?.IsShadowMailbox
    );
}
